export const CkeckColor = (num: number , sign?:string) => {
    if (num > 0) {
        return <span className="text-green-500" ><span >{sign} {num} </span></span>
    }
    else if (num < 0) {
        return <span className="text-red-500" ><span >{sign} {num} </span></span>
    }
    else if (num == 0) {
        return <span className="text-white" ><span >{num} </span></span>
    }
}